export default __webpack_public_path__ + "static/media/fast.a28261c2.svg";